import { Page, NavController, NavParams, Loading } from 'ionic-angular'
import { Component } from '@angular/core'
import { Http } from '@angular/http'
import { ItineraryPage } from '../itinerary/itinerary'
import { DatetimeToDate, Datetime, Minutes } from '../../pipes/datetime'
import * as moment from 'moment'
import { DOMAIN } from '../../config'

@Component({
  templateUrl: 'build/pages/stop/schedules.html',
  pipes: [DatetimeToDate, Datetime, Minutes]
})
export class SchedulesPage {
  private loading: any
  private route: any
  private date: any
  private time: any
  private schedules: any
  private noschedule: any

  private line: any
  private direction: any
  private stop: any

  constructor(private nav: NavController, private http: Http, params: NavParams) {
    this.route = Object.assign({}, params.get('route'))
    if (!this.route.nearest) {
      this.route.nearest = {}
    }

    moment.locale('fr')

    // Custom URL handling
    if (params.get('line') && params.get('direction') && params.get('stop')) {
      this.line = params.get('line')
      this.direction = params.get('direction')
      this.stop = params.get('stop')
    }

    this.date = new Date().toISOString()
    this.time = new Date().getHours() + ':' + new Date().getMinutes()

    this.loading = false
    this.route.schedules = []
    this.route.noschedule = false
  }

  // Come from back transition
  ionViewWillEnter() {
    this.ngAfterViewInit()
  }

  ngAfterViewInit() {
    // (<HTMLInputElement>document.querySelector('input[type="date"]')).value = moment().format('YYYY-MM-DD')
    // (<HTMLInputElement>document.querySelector('input[type="time"]')).value = moment().format('HH:mm')

    if (this.line && this.direction && this.stop) {
      let loader = Loading.create({
        content: 'Récupération des données'
      })
      this.nav.present(loader)

      console.log('test data Refreshing')
      // Retrive all information about line & route
      this.http.get(`//${DOMAIN}/api/line/${encodeURIComponent(this.line)}`)
        .map(res => res.json())
        .subscribe(data => {
          if (!data.error) {
            let line = data.lines[0]
            let route = line.routes[+this.direction]

            this.http.get(`//${DOMAIN}/api/line/${encodeURIComponent(this.stop)}`)
              .map(res => res.json())
              .subscribe(data => {
                if (!data.error) {
                  let stop_point = data.stop_points[0]

                  this.route = {
                    id: this.line,
                    code: line.code,
                    color: line.color,
                    direction: route.direction.name,
                    direction_id: +this.direction,
                    nearest: {
                      title: stop_point.label,
                      id: this.stop
                    }
                  }
                } else {
                  console.log('Error stop occured')
                  return
                }
              }, err => {
                console.error(err)
              }, () => {
                loader.dismiss()
                setTimeout(() => {
                  console.log('laucnh Refreshing')
                  this.refresh()
                })
              })
          } else {
            console.log('Error line occured')
            return
          }
        }, err => {
          console.error(err)
        }, () => {
          loader.dismiss()
        })
    } else {
      setTimeout(() => {
        this.refresh()
      })
    }
  }

  dateChanged(event) {
    this.date = event.year.value + (event.month.value < 10 ? '0' + event.month.value : event.month.value) + (event.day.value < 10 ? '0' + event.day.value : event.day.value)
    this.refresh()
  }

  timeChanged(event) {
    console.log(event)
    this.time = event.hour.text + ':' + event.minute.text
    this.refresh()
  }

  itinerary() {
    this.nav.push(ItineraryPage, {
      stop: this.route.nearest
    })
  }

  refresh() {
    this.loading = true

    this.date = this.date.replace(/-/g, '')
    let time = this.time.replace(/:/g, '')
    let datetime = `${this.date}T${time}`

    // Remove the "no schedule" if exist
    this.route.schedules = []
    if (this.route.noschedule) {
      this.route.noschedule = false
    }

    this.http
      .get(`//${DOMAIN}/api/schedules?line=${this.route.id}&stop=${this.route.nearest.id}&from_datetime=${datetime}&count=3`)
      .map(res => res.json())
      .subscribe(data => {
        if (data.departures && data.departures.length) {
          this.route.schedules = data.departures
        } else {
          this.route.noschedule = true
        }
      },
      err => console.error(err), () => {
        this.loading = false
      })
  }
}
